import Cookies from 'js-cookie'
const state = ()=>({
    sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false
      },
      device: 'desktop',
      sysDwidth: '70%'
  })
  const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened
        state.sidebar.withoutAnimation = false
        if (state.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
      },
      CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0)
        state.sidebar.opened = false
        state.sidebar.withoutAnimation = withoutAnimation
      },
      TOGGLE_DEVICE: (state, device) => {
        state.sysDwidth = device === 'mobile' ? '95%' : '70%'
        state.device = device
      },

  }
  const actions = {
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
  }
  export default {
    namespaced: true,
    state,
    actions,
    mutations
  }
  


// WEBPACK FOOTER //
// ./src/store/module/app.js